<template>
  <div
    class="kd-font-select"
    v-click-outside="clickOutsideConfig"
  >
    <div
      class="kd-font-select__head"
      @click="toggle"
      :style="{
        backgroundImage: selectedBackgroundImageCss,
      }"
    >
    <img
      :src="arrowDownIcon"
      class="kd-font-select__toggle-icon"
      :class="{
        'kd-font-select__toggle-icon--rotated': !isClosed,
      }"
    >
    </div>
    <div
      class="kd-font-select__list"
      :class="{
        'kd-font-select__list--is-closed': isClosed,
      }"
    >
      <div
        class="kd-font-select__item"
        v-for="option in options"
        :key="option.id"
        :style="{
          backgroundImage: `url(${option.imageUrl})`,
        }"
        @click="onItemSelect(option.name)"
      >
      </div>
    </div>
  </div>  
</template>

<script>
import * as log from 'loglevel';
import windsongImg from '@/shared/assets/webfont-images/windsong.png';

export default {
  props: {
    options: Array,
    selected: String, // font name
  },
  model: {
      prop: 'selected',
      event: 'change'
  },
  data() {
    return {
      isClosed: true,
      arrowDownIcon: require('../assets/images/icons/arrow-down.svg'),
      clickOutsideConfig: {
        handler: this.onClickOutside,
        middleware: this.shouldDeactivateLayer,
        events: ['dblclick', 'click'],
      },
    }; 
  },
  computed: {
    selectedBackgroundImageCss() {
      if (!this.options || !this.selected) { return ''; }
      const selectedOption = this.options.find(o => o.name === this.selected);
      if (!selectedOption) { return ''; }
      return `url(${selectedOption.imageUrl})`
    },
  },
  methods: {
    onItemSelect(itemName) {
      if (itemName !== this.selected) {
        this.$emit('change', itemName);
      }
    },
    toggle() {
      this.isClosed = !this.isClosed;
    },
    /**
     * Called when there is a selected layer and user clicks outside,
     * deselects active layer then.
     * Uses shouldDeactivateLayer to check if this function is called or click is being
     * ignored (e.g. when clicking on layer settings)
     */
    onClickOutside() {
      this.isClosed = true;
    },

    /**
     * This check should return false for all classes that
     * should not close the dropdown on click outside
     */
    shouldDeactivateLayer(event) {
      return true;
    },
  },
};
</script>

<style lang="scss">
.kd-font-select {
  position: relative;
}

.kd-font-select__head {
  height: 30px;
  cursor: pointer;
  background-color: #EDEDED;
  background-size: 100% auto;
  background-position-y: 31%; // optically center, the image is higher than 30px
  border-radius: 3px;
  
}

.kd-font-select__toggle-icon {
  width: 10px;
  position: absolute;
  top: 11px;
  right: 10px;
  opacity: 0.4;

  &--rotated {
    transform: rotate(180deg);
  }
}

.kd-font-select__list {
  border-top: 1px solid #e2e2e2;
  position: absolute;
  top: 30px;
  left: 0;
  width: 100%;
  height: 240px;
  overflow: scroll;
  z-index: 10;
  transition: height 100ms ease-out;
  border-radius: 3px;
  overflow-x: hidden;

  &--is-closed {
    height: 0;
    pointer-events: none;
    transition: height 100ms ease-out;
    border-top: 1px solid transparent;
  }
}

.kd-font-select__item {
  height: 30px;
  border-bottom: 1px solid #e2e2e2;
  cursor: pointer;
  background-size: 100% auto;
  background-position-y: 31%; // optically center, the image is higher than 30px

  &:hover {
    // try to get as close as possible to the blue CI color
    filter: brightness(0.57) sepia(1) hue-rotate(155deg) saturate(2);
  }
}
</style>
